import React, { Component } from 'react'
import { Form, Checkbox } from 'antd';
import { InputNumber } from '../../../../../components/common/input-number';

export class CancelPolicy extends Component {

  render() {
    const { unlimitEdit, isOwner, typeOption } = this.props;
    return <>
      <div className="title-contract">8. Huỷ hợp đồng*</div>
      <Form.Item
        wrapperCol={15}
        label={<div className="label-special"><div className="plus">+</div><div>Huỷ hợp đồng báo trước:</div></div>}
        name={'days_inform_before_early_termination'}
        rules={[
          {
            required: true,
            message: `Vui lòng nhập số ngày báo trước!`,
          }
        ]}>
        <InputNumber disabled={!unlimitEdit} suffix={"ngày"} />
      </Form.Item>
      <Form.Item
        wrapperCol={15}
        label={<div className="label-special">
          <div className="plus">+</div>
          <div>Tỷ lệ % phạt khách hàng khi chấm dứt sớm HĐ:</div>
        </div>}
        name={'penalty_rate_early_termination'}
        rules={[
          {
            required: true,
            message: `Vui lòng nhập định tỷ lệ phạt!`,
          },
          {
            pattern: /^100$|^[0-9]{1,2}$|^[0-9]{1,2}\.[0-9]{1,100}$/,
            message: `Vui lòng nhập giá trị trong trong khoảng 0-100!`,
          },
        ]}>
        <InputNumber percent className={(!isOwner && typeOption !== 'create_new') ? 'hidePrice' : ''} disabled={!unlimitEdit || (typeOption !== 'create_new' && !isOwner)} max={100} suffix={"%"} />
      </Form.Item>
    </>
  }
}
